module.exports = __webpack_public_path__ + "static/media/couple-kitchen.e9f4a383.jpg";